import React, { Component } from "react";

class SectionYouAreADriver extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-57155aa6 elementor-hidden-mobile elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="57155aa6"
          data-element_type="section"
          id="motorista"
          data-settings='{"background_background":"classNameic"}'
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-5624f86"
              data-id="5624f86"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-4a4400cf elementor-widget elementor-widget-video"
                  data-id="4a4400cf"
                  data-element_type="widget"
                  data-settings='{"youtube_url":"https:\/\/youtu.be\/7AhCVN8EFZk?si=DcD3gKwlzTUIO1bc","image_overlay":{"url":"","id":"","size":"","alt":"","source":"library"},"show_image_overlay":"yes","video_type":"youtube","controls":"yes"}'
                  data-widget_type="video.default"
                >
                  <div className="elementor-widget-container">
                    <div className="elementor-wrapper elementor-open-inline">
                      {/*
                      <iframe
                        className="elementor-video"
                        frameBorder="0"
                        allowfullscreen=""
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        title="Sig Mobi Motoristas"
                        width="640"
                        height="360"
                        src="https://www.youtube.com/embed/C2cX0juzbWM?controls=1&amp;rel=0&amp;playsinline=0&amp;modestbranding=0&amp;autoplay=0&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fsigmobioficial.com&amp;widgetid=5"
                        id="widget6"
                      ></iframe>{" "}*/}
                      <iframe width="640" height="360" src="https://www.youtube.com/embed/7AhCVN8EFZk" title="Sig Mobi Motoristas" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowfullScreen></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-2a1772b5"
              data-id="2a1772b5"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-1a67bedc elementor-widget elementor-widget-text-editor"
                  data-id="1a67bedc"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <p>
                      VOCÊ É <span style={{ color: "#ef3087" }}>MOTORISTA</span>{" "}
                      DE APP? 
                    </p>{" "}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-f847e66 elementor-widget elementor-widget-text-editor"
                  data-id="f847e66"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <p>
                      Saiba que, na{" "}
                      <span style={{ color: "#ef3087" }}>SIG MOBI</span>, o
                      poder está em suas mãos!
                    </p>{" "}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-4c854d88 animated-fast elementor-invisible elementor-widget elementor-widget-heading"
                  data-id="4c854d88"
                  data-element_type="widget"
                  data-settings='{"_animation":"fadeInUp"}'
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container">
                    <h2 className="elementor-heading-title elementor-size-xxl">
                      Assista ao vídeo e conheça as vantagens!
                    </h2>{" "}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-1f07950b elementor-align-left bt-refer cadastro elementor-widget elementor-widget-button"
                  data-id="1f07950b"
                  data-element_type="widget"
                  data-widget_type="button.default"
                >
                  <div className="elementor-widget-container">
                    <div className="elementor-button-wrapper">
                      <a
                        className="elementor-button elementor-button-link elementor-size-lg"
                        href={this.props.url} style={{backgroundColor: '#57c600'}}
                      >
                        <span className="elementor-button-content-wrapper">
                          <span className="elementor-button-text">
                            QUERO ME CADASTRAR AGORA
                          </span>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-eba53f9 elementor-hidden-desktop elementor-hidden-tablet elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="eba53f9"
          data-element_type="section"
          data-settings='{"background_background":"classic"}'
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-47ac16ee"
              data-id="47ac16ee"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-659465d4 elementor-widget elementor-widget-text-editor"
                  data-id="659465d4"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <p>
                      <span style={{verticalAlign: 'inherit'}}>
                        <span style={{verticalAlign: 'inherit'}}>VOCÊ É </span>
                      </span>
                      <span style={{color: '#ef3087'}}>
                        <span style={{verticalAlign: 'inherit'}}>
                          <span style={{verticalAlign: 'inherit'}}>
                            MOTORISTA
                          </span>
                        </span>
                      </span>
                      <span style={{verticalAlign: 'inherit'}}>
                        <span style={{verticalAlign: 'inherit'}}>
                          {" "}
                          DE APP?&nbsp;
                        </span>
                      </span>
                    </p>{" "}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-43bd4bfd elementor-widget elementor-widget-text-editor"
                  data-id="43bd4bfd"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <p>
                      <span style={{verticalAlign: 'inherit'}}>
                        <span style={{verticalAlign: 'inherit'}}>
                          Saiba que, na{" "}
                          <span style={{color: '#ef3087'}}>SIG MOBI</span>, o poder
                          está em suas mãos!
                        </span>
                      </span>
                    </p>{" "}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-b734d7a elementor-widget elementor-widget-video"
                  data-id="b734d7a"
                  data-element_type="widget"
                  data-settings='{"youtube_url":"https:\/\/youtu.be\/7AhCVN8EFZk?si=DcD3gKwlzTUIO1bc","image_overlay":{"url":"","id":"","size":"","alt":"","source":"library"},"show_image_overlay":"yes","video_type":"youtube","controls":"yes"}'
                  data-widget_type="video.default"
                >
                  <div className="elementor-widget-container">
                    <div className="elementor-wrapper elementor-open-inline">
                      <iframe
                        className="elementor-video"
                        frameBorder="0"
                        allowfullscreen=""
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        title="Sig Mobi Motoristas"
                        width="640"
                        height="360"
                        src="https://www.youtube.com/embed/C2cX0juzbWM?controls=1&amp;rel=0&amp;playsinline=0&amp;modestbranding=0&amp;autoplay=0&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fsigmobioficial.com&amp;widgetid=7"
                        id="widget8"
                      ></iframe>{" "}
                    </div>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-edc13b7 animated-fast elementor-widget elementor-widget-heading animated fadeInUp"
                  data-id="edc13b7"
                  data-element_type="widget"
                  data-settings='{"_animation":"fadeInUp"}'
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container">
                    <h2 className="elementor-heading-title elementor-size-xxl">
                      Assista ao vídeo e conheça as vantagens!
                    </h2>{" "}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-3d713b4d elementor-align-center bt-refer cadastro elementor-widget elementor-widget-button"
                  data-id="3d713b4d"
                  data-element_type="widget"
                  data-widget_type="button.default"
                >
                  <div className="elementor-widget-container">
                    <div className="elementor-button-wrapper">
                      <a
                        className="elementor-button elementor-button-link elementor-size-lg"
                        href={this.props.url} style={{backgroundColor: '#57c600'}}
                      >
                        <span className="elementor-button-content-wrapper">
                          <span className="elementor-button-text">
                            QUERO ME CADASTRAR AGORA
                          </span>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default SectionYouAreADriver;
